import apiClient from "@/api/index";
import { PROJECT_PREFIX } from "@/constants/projects"
import { buildNotificationUrl } from "@/utils/notificationUrl"

export const notificationsModule = {
  namespaced: true,

  state: () => ({
    notifications: null,
    not_readed_count: 0,
    new_notification: null,
  }),

  mutations: {
    setNotifications(state, data) {
      const count = data.filter((x) => x.readed_at == null).length;
      data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      const notifByDay = {};
      data.forEach((notif) => {
        let date = new Date(notif.created_at)
        date = new Intl.DateTimeFormat('ru-RU', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).format(date)
        if (!notifByDay[date]) {
          notifByDay[date] = [];
        }
        notifByDay[date].push(notif);
      });
      state.notifications = notifByDay;
      state.not_readed_count = count;
    },

    setNewNotifications(state, data) {
      data.message.time = `${new Date().getHours()}:${new Date().getMinutes()}`;
      state.new_notification = data.message;
    },

    clearNewNotifications(state) {
      state.new_notification = null;
    },
  },

  actions: {
    async fetchNotifications({ state, commit }) {
      try {
        const response = await apiClient.get(PROJECT_PREFIX.tcode + "/notifications/", {
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });
        commit("setNotifications", response.data.results);
      } catch (err) {
        alert(err);
      }
    },

    notificationConnect({ commit, dispatch }, user) {
      if (user?.id == null) return;
      if (this.connection) this.connection.close();
      this.connection = new WebSocket(
        buildNotificationUrl(
          process.env.VUE_APP_API_BASE_URL,
          user.id,
          process.env.VUE_APP_WS_BASE_URL,
          window.location.origin,
        )
      );

      this.connection.onmessage = function (event) {
        commit("setNewNotifications", JSON.parse(event.data));
        dispatch("fetchNotifications");
      };

      this.connection.onopen = function (event) {
        // console.log(event)
        // console.log("Соединение с WebSocket, успешно...")
      };
    },

    async readNotifications({ state, dispatch }) {
      for (let i = 0; i < state.notifications.length; i++) {
        if (!state.notifications[i].readed_at) {
          try {
            const response = await apiClient.patch(
              PROJECT_PREFIX.tcode + "/notifications/" + state.notifications[i].id,
              {
                readed_at: new Date().toISOString(),
              },
              {
                headers: {
                  Authorization: "Token " + localStorage.getItem("token"),
                },
              }
            );
          } catch (err) {
            alert(err);
          }
        }
      }

      dispatch("fetchNotifications");
    },
  },
};
